import React, { FC } from 'react';

import { useSelector } from 'react-redux';

import { ContentModule } from '@nhl/nhl-react-ui/lib/ContentModule';
import LoadingDisplay from '@nhl/nhl-react-ui/lib/LoadingDisplay';

import { State } from '~/core/types';

import { LeaderModule } from '../index';

import { FeaturedStatsContainer, Leaders } from './styles';

type LeaderContainerProps = {
    seasonIdForDisplay?: number;
    sendGaEvent: (value: string) => void;
};

// There will be content modules for Fantasy stats and "Beyond the Numbers" but the content is still to be determined.
const LeaderContainer: FC<LeaderContainerProps> = ({ seasonIdForDisplay, sendGaEvent }) => {
    const leaderData = useSelector((state: State) => state.leaders);
    const baseUrl = `${window.__BASE_REST_URL__}`;
    const leaderModules = leaderData?.map((leaderCategory) => (
        <LeaderModule
            key={leaderCategory.title}
            title={leaderCategory.title}
            measures={leaderCategory.measures}
            requirements={leaderCategory.requirements}
            seasonId={seasonIdForDisplay}
            sendGaEvent={sendGaEvent}
        />
    ));

    return (
        <LoadingDisplay isLoading={leaderData?.length === 0}>
            <Leaders>{leaderModules}</Leaders>
            <FeaturedStatsContainer>
                <ContentModule templateKey="StatsHomePage" sequence={3} baseUrl={baseUrl} isPublic />
            </FeaturedStatsContainer>
            {/*
                This has not been in use for a while, and would need a css redesign if he wanted to add in these sections
                <section>
                    <CMSSection templateKey="StatsHomePage" sequence={1} baseUrl={baseUrl} />
                    <CMSSection templateKey="StatsHomePage" sequence={2} baseUrl={baseUrl} />
                </section>
                 */}
        </LoadingDisplay>
    );
};

export default LeaderContainer;
